module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki11_sp-c3ff3155f68a5193dcf637b26681b082.jpg";